export enum EBrokenLinksErrors {
	SOURCE_NOT_FOUND = 'source_not_found',
	SOURCE_INACTIVE = 'source_inactive',
	OFFER_NOT_FOUND = 'offer_not_found',
	OFFER_INACTIVE = 'offer_inactive',
	PUBLISHER_INACTIVE = 'publisher_inactive',
	SOURCE_OFFER_RELATION_INACTIVE = 'source_offer_relation_inactive',
	REDIRECT_URL_NOT_FOUND = 'redirect_url_not_found',
}
